import React, { useState } from 'react';

const AddFactoryPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAddFactoryPopup, setShowAddFactoryPopup] =
      useState<boolean>(false);

    const addFactoryToggleHandler = () => {
      setShowAddFactoryPopup(!showAddFactoryPopup);
    };

    return (
      <Component
        showAddFactoryPopup={showAddFactoryPopup}
        addFactoryToggleHandler={addFactoryToggleHandler}
        {...props}
      />
    );
  };

export default AddFactoryPopupHOC;
